// {% BEGIN MODIFIED CODE BLOCK %}
// Maximum quantity allowed per item unless the product handle contains an exempt string.
const MAX_QUANTITY = 4;
const EXEMPT_HANDLE_SUBSTRINGS = [
  "cid-timeless-artificer",
  "dragons-approach",
  "hare-apparent",
  "persistent-petitioners",
  "rat-colony",
  "relentless-rats",
  "shadowborn-apostle",
  "slime-against-humanity",
  "tempest-hawk",
  "templar-knight",
  "seven dwarves",
  "wastes",
  "plains",
  "island",
  "swamp",
  "mountain",
  "forest",
]; // Add more strings to this array as needed

function isExemptProduct(handle) {
  if (!handle) return false;
  const lowerHandle = handle.toLowerCase();
  return EXEMPT_HANDLE_SUBSTRINGS.some((substr) =>
    lowerHandle.includes(substr.toLowerCase()),
  );
}
// {% END MODIFIED CODE BLOCK %}

if (!customElements.get("quick-add-bulk")) {
  customElements.define(
    "quick-add-bulk",
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector("quantity-input");

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(
              event.target.dataset.index,
              parseInt(event.target.value),
            );
          } else {
            // {% BEGIN MODIFIED CODE BLOCK %}
            // Clamp quantity to MAX_QUANTITY before validating, unless exempt
            const productHandle = this.dataset.productHandle || "";
            if (!isExemptProduct(productHandle)) {
              const raw = parseInt(event.target.value);
              if (!isNaN(raw) && raw > MAX_QUANTITY) {
                event.target.value = MAX_QUANTITY;

                // Add the visual feedback
                event.target.classList.remove("quantity-limit-hit");
                void event.target.offsetWidth; // Trigger reflow to restart animation
                event.target.classList.add("quantity-limit-hit");
                this.showAddedToCartToast(
                  "Maximum Purchasable Quantity Reached",
                );
                return; // Don't proceed to validateQuantity
              }
            }
            // {% END MODIFIED CODE BLOCK %}
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener("change", debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (
              event.source === "quick-add" ||
              (event.cartData.items &&
                !event.cartData.items.some(
                  (item) => item.id === parseInt(this.dataset.index),
                )) ||
              (event.cartData.variant_id &&
                !(event.cartData.variant_id === parseInt(this.dataset.index)))
            ) {
              return;
            }
            // If its another section that made the update
            this.onCartUpdate().then(() => {
              this.listenForActiveInput();
              this.listenForKeydown();
            });
          },
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector("quantity-input input");
      }

      selectProgressBar() {
        return this.querySelector(".progress-bar-container");
      }

      listenForActiveInput() {
        if (!this.classList.contains("hidden")) {
          this.input?.addEventListener("focusin", (event) =>
            event.target.select(),
          );
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.input?.addEventListener("keydown", (event) => {
          if (event.key === "Enter") {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          "keypress",
          () => {
            event.target.setCustomValidity("");
          },
          { once: true },
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId = this.closest(
            ".collection-quick-add-bulk",
          ).dataset.id;
        }

        return this._sectionId;
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html",
              );
              const sourceQty = html.querySelector(
                `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
              );
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsUrl() {
        const pageParams = new URLSearchParams(window.location.search);
        const pageNumber = decodeURIComponent(pageParams.get("page") || "");

        return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ""}`;
      }

      // {% BEGIN MODIFIED CODE BLOCK %}
      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove("hidden");

        // Enforce per-item quantity cap unless this product is exempt
        const productHandle = this.dataset.productHandle || "";
        if (!isExemptProduct(productHandle)) {
          for (const id of Object.keys(items)) {
            const qty = parseInt(items[id]);
            if (!isNaN(qty) && qty > MAX_QUANTITY) {
              items[id] = MAX_QUANTITY;
              // Clamp the visible input so the UI stays in sync
              const input = this.querySelector(`[data-index="${id}"]`);
              if (input) {
                input.value = MAX_QUANTITY;

                // Add the visual feedback
                input.classList.remove("quantity-limit-hit");
                void input.offsetWidth; // Trigger reflow to restart animation
                input.classList.add("quantity-limit-hit");
                this.showAddedToCartToast(
                  "Maximum Purchasable Quantity Reached",
                );
              }
            }
          }
        }

        // Check if all items in this batch are being set to 0
        const quantities = Object.values(items);
        const isRemoval =
          quantities.length > 0 &&
          quantities.every((qty) => parseInt(qty) === 0);

        // Define your messages
        const addMessage = "Added to cart!";
        const removeMessage = "Removed from Cart!";

        // Determine which message to use
        const toastMessage = isRemoval ? removeMessage : addMessage;

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map(
            (section) => section.section,
          ),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            // Pass the correct message to the toast
            this.showAddedToCartToast(toastMessage);
            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "quick-add",
              cartData: parsedState,
            });
          })
          .catch(() => {
            // Commented out for now and will be fixed when BE issue is done https://github.com/Shopify/shopify/issues/440605
            // e.target.setCustomValidity(error);
            // e.target.reportValidity();
            // this.resetQuantityInput(ids[index]);
            // this.selectProgressBar().classList.add('hidden');
            // e.target.select();
            // this.cleanErrorMessageOnType(e);
          })
          .finally(() => {
            this.selectProgressBar().classList.add("hidden");
            this.setRequestStarted(false);
          });
      }

      showAddedToCartToast(message) {
        // 1. Add 'message' as a parameter
        const toast = document.getElementById("add-to-cart-toast");
        if (!toast) return;

        // 2. Set the toast's text to the message
        toast.textContent = message;

        // Add the 'show' class to trigger the animation
        toast.classList.add("show");

        // Set a timer to remove the 'show' class after 3 seconds
        setTimeout(() => {
          toast.classList.remove("show");
        }, 3000);
      }
      // {% END MODIFIED CODE BLOCK %}

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
          {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
          },
          {
            id: "CartDrawer",
            selector: ".drawer__inner",
            section: "cart-drawer",
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) =>
          ids.includes(element.id),
        );
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (section.section === "cart-drawer") {
            sectionElement
              .closest("cart-drawer")
              ?.classList.toggle(
                "is-empty",
                parsedState.items.length.length === 0,
              );
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    },
  );
}
